import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { AuthFacadeService, AuthService, NotificationService } from '@dot-it/jml-lib'

export enum ServerErrorCode {
  GENERIC_ERROR = 1,
  UNKNOWN_TOKEN = 4,
  LOST_UPDATE_FAILED = 30,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500
}

@Injectable()
export class HttpErrorRepsonseInterceptor implements HttpInterceptor {
  errorCodeFourBlockActive = false

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private authFacade: AuthFacadeService
  ) {}

  private logError(error) {
    switch (error.type) {
      case 'ERROR':
        this.notificationService.addErrorNotification(error.message, error.output, error.ts, error.trace, error.code)
        break
      case 'WARNING':
        this.notificationService.addWarnNotification(error.message, error.output)
        break
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error['status'] === 0) {
          this.notificationService.addErrorNotification('Server nicht erreichbar. Bitte Netzwerkverbindung prüfen.')
        } else {
          /* this block avoids multiple 'invalid token' messages and hides message if user logs out*/
          if (!!error && !!error.error && !!error.error.code && error.error.code === ServerErrorCode.UNKNOWN_TOKEN) {
            if (!this.errorCodeFourBlockActive && !req.url.endsWith('/logout')) {
              this.errorCodeFourBlockActive = true
              setTimeout(() => {
                this.errorCodeFourBlockActive = false
              }, 1000)
              this.notificationService.addErrorNotification(
                error.error.message,
                error.error.output,
                error.error.ts,
                error.error.trace,
                error.error.code
              )
            } else {
              console.error('Error code ' + error['error']['code'] + '\n' + error['error']['message'])
            }
            // if user is logged in, he needs to be logged out and redirected to login
            if (this.authService.isLoggedIn) {
              this.authFacade.logout(false)
            }
          } else if (error.error instanceof Blob) {
            // If a request asks for Content-Type: Blob (e.g. File Downloads) angular will also serve the error data as a blob for some reason
            let reader = new FileReader()
            reader.onload = (e: Event) => {
              try {
                const errmsg = JSON.parse((<any>e.target).result)
                this.logError(errmsg)
              } catch (e) {
                console.error('Error while trying to read error response from blob', e)
              }
            }
            reader.readAsText(error.error)
          } else {
            this.logError(error.error)
          }
        }
        return throwError(error)
      })
    )
  }
}
